import { z } from 'zod'

/**
 * Variables for post-acceptance "account activated" confirmation emails.
 *
 * Sent after a user successfully completes the invitation acceptance flow
 * (org_owner provisioning a new tenant, DCP admin gaining multi-org access,
 * or team member joining an existing org). One Listmonk template covers all
 * three audiences; the optional `organization_name` lets the template show
 * tenant context when present (org/team flows) and stay generic when not
 * (admin flow, which has no single-org context).
 *
 * Asymmetry with invitation schemas:
 * - `confirmation_url` is replaced by `login_url` — the recipient already
 *   has an active account, so the CTA points at sign-in.
 * - `organization_name` is optional (admin invites have no org context).
 */
export const accountActivatedVariablesSchema = z.object({
  first_name: z.string().trim().min(1),
  last_name: z.string().trim().min(1).optional(),
  organization_name: z.string().trim().min(1).optional(),
  login_url: z.string().url(),
})
export type AccountActivatedVariables = z.infer<typeof accountActivatedVariablesSchema>
